import {
  INTEGER,
  TEXT,
  chapterId,
  chapter_chapterId,
  id,
  label,
  position,
  quote,
  timestamp,
  userId,
  verseRange,
} from '../constants/stringsAndFields';
import {isNotEmpty} from '../utils/arrays';
import {CHAPTER_TABLE} from './chapter';
import {
  checkTableExists,
  deleteData,
  executeTransaction,
  insertData,
  selectData,
  selectDataMultiWhere,
  updateData,
} from './common';
import {getActiveUserId} from './currentUser';
import {APP_USER_TABLE} from './user';
import {LOCAL_DEFAULT_USER_ID} from './userConstants';
import {runSqlCmd, exportDatabase} from './sqlOperations';

export const FAVORITE_QUOTE_TABLE = 'FavoriteQuote';
const keys = [
  id,
  userId,
  chapter_chapterId,
  quote,
  label,
  position,
  timestamp,
  verseRange,
];

const defaultUserIdSql = `'${LOCAL_DEFAULT_USER_ID}'`;

// TODO: add index which is used for query
export const createFavoriteQuoteTable = async tx => {
  await runSqlCmd(tx, `DROP TABLE IF EXISTS ${FAVORITE_QUOTE_TABLE};`);
  await runSqlCmd(
    tx,
    `CREATE TABLE IF NOT EXISTS ${FAVORITE_QUOTE_TABLE}(
      ${id} ${TEXT} PRIMARY KEY NOT NULL,
      ${userId} ${TEXT} NOT NULL DEFAULT ${defaultUserIdSql},
      ${chapter_chapterId} ${TEXT},
      ${quote} ${TEXT},
      ${label} ${TEXT},
      ${position} ${INTEGER},
      ${timestamp} ${INTEGER},
      ${verseRange} ${TEXT},
      FOREIGN KEY(${userId}) REFERENCES ${APP_USER_TABLE}(${userId}) ON DELETE CASCADE,
      FOREIGN KEY(${chapter_chapterId}) REFERENCES ${CHAPTER_TABLE}(${chapterId}) ON UPDATE NO ACTION ON DELETE NO ACTION);`,
  );
};

export const reCreateFavoriteQuoteTableAndData = async (tx, cmds) => {
  await createFavoriteQuoteTable(tx);
  await executeTransaction(tx, cmds);
};

export const insertFavoriteQuote = async (tx, favoriteQuote) => {
  const row = {
    ...favoriteQuote,
    [userId]: favoriteQuote[userId] ?? getActiveUserId(),
  };
  await insertData(tx, FAVORITE_QUOTE_TABLE, keys, row);
  await exportDatabase(tx);
};

export const deleteAllFavoriteQuotes = async tx => {
  await runSqlCmd(
    tx,
    `DELETE FROM ${FAVORITE_QUOTE_TABLE} WHERE ${userId} = '${getActiveUserId()}';`,
  );
  await exportDatabase(tx);
};

export const deleteFavoriteQuote = async (tx, favoriteQuote) => {
  await deleteData(tx, FAVORITE_QUOTE_TABLE, favoriteQuote[id]);
  await exportDatabase(tx);
};

export const updateFavoriteQuote = async (tx, favoriteQuote) => {
  const row = {
    ...favoriteQuote,
    [userId]: favoriteQuote[userId] ?? getActiveUserId(),
  };
  await updateData(tx, FAVORITE_QUOTE_TABLE, row, id);
  await exportDatabase(tx);
};

export const getFavoriteQuotes = async tx => {
  const favoriteQuotes = await selectData(
    tx,
    FAVORITE_QUOTE_TABLE,
    keys,
    userId,
    getActiveUserId(),
  );
  return isNotEmpty(favoriteQuotes) ? favoriteQuotes : [];
};

export const getFavoriteQuote = async (tx, dataId) => {
  const favoriteQuotes = await selectDataMultiWhere(
    tx,
    FAVORITE_QUOTE_TABLE,
    keys,
    [id, userId],
    [dataId, getActiveUserId()],
    [],
    false,
  );
  return isNotEmpty(favoriteQuotes) ? favoriteQuotes[0] : null;
};

export const checkFavoriteQuoteTable = async tx => {
  return await checkTableExists(tx, FAVORITE_QUOTE_TABLE);
};
